import React from "react";
import { Route, Routes } from "react-router-dom";
import './App.css';
import './header.css';
import './footer.css';
import './tour.css';
import './hotellist.css';
import './hotels.css';
import './hoteldetails.css';
import './contact.css';
import './tourgridtwo.css';
import './rentalcar.css';
import './ferry.css';
import './pickupdrop.css';
import './airportbooking.css';
import './hourlybooking.css';
import './ferrybooking.css';
import './ferrylist.css';
import './seatselection.css';
import './ferryseatbooking.css';
import './nautikaseatoverlay.css';
import './privacypolicy.css';
import './paymentpolicy.css';
import './refund.css';
import './websiteusage.css';
import './terms.css';
import './cookie.css';
import './signupandlogin.css';
import './profileaccount.css';
import './bookinghistory.css';
import './popupform.css';
import "./dashboard.css"; 
import "react-datepicker/dist/react-datepicker.css";
import "rc-slider/assets/index.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-multi-carousel/lib/styles.css";
import Home from './Component/Home';
import TourPackage from './Component/tourPackage';
import PackageDetails from "./Component/packageDetails";
import Hotellist from "./Component/Hotellist";
import Hoteldetails from "./Component/Hoteldetails";
import Contact from "./Component/Contact";
import CarRental from "./Component/carRental";
import PickupDrop from "./Component/PickupDrop";
import Ferry from "./Component/Ferry";
import WaterSports from "./Component/WaterSports";
import FerryBooking from "./Component/FerryBooking";
import AirportBooking from "./Component/AirportBooking";
import HourlyBooking from "./Component/HourlyBooking";
import SeatBooking from "./Component/SeatSelection";
import FerrySeatBooking from "./Component/FerrySeatBooking";
import FerryList from "./Component/FerryList";
import Privacy from "./Component/Privacypolicy";
import Paymentpolicy from "./Component/Paymentpolicy";
import Refund from "./Component/Refund";
import Websiteusage from "./Component/Websiteusage";
import TermsandConditions from "./Component/Terms";
import Cookie from "./Component/Cookie";
import Login from "./Component/Login";
import Signup from "./Component/Signup";
import Profileaccount from "./Component/Profileaccount";
import Bookinghistory from "./Component/Bookinghistory";
import Dashboard from "./Component/Dashboard";
import OtpModal from "./Component/OtpModal";
import CarPackage from "./Component/carPackages";
import CarPackageDetails from "./Component/carpackageDetails";
import Hotels from "./Component/hotels";
import Checkout from "./Component/checkout";
import WaterSportsDetails from "./Component/waterSportsDetails";




function App() {
  return (
    <>
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/tour-packages" element={<TourPackage />} />
        <Route path="/tour-packages/:categorySlug" element={<TourPackage />} />
        <Route path="/package-details/:packageSlug" element={<PackageDetails />} />
        <Route path="hotellist" element={<Hotellist />} />
        <Route path="hoteldetails/:id" element={<Hoteldetails />} />
        <Route path="contact" element={<Contact />} />
        <Route path="carrental" element={<CarRental />} />
        <Route path="pickup-drop" element={<PickupDrop />} />
        <Route path="ferry" element={<Ferry />} />
        <Route path="ferrybooking" element={<FerryBooking />} />
        <Route path="ferrylist" element={<FerryList/>} />
        <Route path="booknow" element={<SeatBooking/>} />
        <Route path="passengerdetails" element={<FerrySeatBooking/>} />
        <Route path="watersports" element={<WaterSports />} />
        <Route path="airport-car-booking" element={<AirportBooking />} />
        <Route path="hourly-car-booking" element={<HourlyBooking />} />
        <Route path="privacy-policy" element={<Privacy/>} />
        <Route path="payment-policy" element={<Paymentpolicy/>} />
        <Route path="refund" element={<Refund/>} />
        <Route path="websiteusage" element={<Websiteusage/>} />
        <Route path="terms-conditions" element={<TermsandConditions/>} />
        <Route path="cookie" element={<Cookie/>} />
        <Route path="login" element={<Login/>} />
        <Route path="signup" element={<Signup/>} />
        <Route path="account" element={<Profileaccount/>} />
        <Route path="booking-history" element={<Bookinghistory/>} />
        <Route path="dashboard" element={<Dashboard/>} />
        <Route path="verifyOtp" element={<OtpModal/>} />
         <Route path="car-rental-package" element={<CarPackage/>} />
         <Route path="/car-package-details/:slug" element={<CarPackageDetails />} />
          <Route path="/watersport-details/:id" element={<WaterSportsDetails />} />
          <Route path="/hotels" element={<Hotels />} />
             <Route path="/checkout" element={<Checkout />} />
        

      </Routes>
    </>
  );
}

export default App;
